import { useState } from "react";

import { Switch, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import { useTheme } from "@mui/material/styles";
import { v4 as uuid } from "uuid";

import constants from "../../assets/constants";
import Dialog from "../ui/omniDialog";
import DialogActions from "../ui/omniDialogActions";
import DialogContent from "../ui/omniDialogContent";
import DialogTitle from "../ui/omniDialogTitle";
import OmniMenuItem from "../ui/omniMenuItem";
import OmniTextField from "../ui/omniTextField";

// ES Modules import

const BotpressBulkFeedbackDialog = props => {
  const {
    open,
    onClose,
    onAccept,
    dialogTitle = "Edit Feedback",
    okMessage = "Ok",
    cancelMessage = "Cancel",
    maxWidth = "xs",
    fullWidth = true,
  } = props;

  const theme = useTheme();

  //input
  const [response, setResponse] = useState("");
  const [archived, setArchived] = useState(false);
  const [status, setStatus] = useState(constants.feedbackStatus[2].value); //default to open

  const onAcceptHandler = () => {
    let theUpdates = {
      status: status,
      archived: archived,
      response: response,
    };
    onAccept(theUpdates);
  };

  const onCloseHandler = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          onCloseHandler();
        }
      }}
      disableEscapeKeyDown
      maxWidth={maxWidth}
      fullWidth={fullWidth}
    >
      <DialogTitle onClose={onCloseHandler}>{dialogTitle}</DialogTitle>
      <DialogContent>
        <Grid container spacing={1} size={{ xs: 12 }}>
          <Grid item container size={{ xs: 5 }}>
            <OmniTextField
              label="Feedback Status"
              type="textInput"
              select
              name={uuid()} //prevents AutoComplete Suggestions
              variant="outlined"
              id={"organizationType"}
              value={status}
              onChange={event => {
                setStatus(event.target.value);
              }}
            >
              {constants.feedbackStatus.map(orgType => (
                <OmniMenuItem key={orgType.value} value={orgType.value}>
                  {orgType.label}
                </OmniMenuItem>
              ))}
            </OmniTextField>
          </Grid>
          <Grid item container size={{ xs: 7 }}>
            <Box
              sx={{
                width: "100%",
                flexDirection: "row",
                marginTop: "4px",
                marginBottom: "10px",
                justifyContent: "right",
                display: "flex",
              }}
            >
              <Typography variant="body1" sx={{ marginTop: "12px", width: "auto" }}>
                Archive Comments
              </Typography>
              <Switch
                sx={{ marginTop: "4px" }}
                checked={archived}
                onChange={() => {
                  setArchived(val => !val);
                }}
              />
            </Box>
          </Grid>

          <Grid item container size={{ xs: 12 }}>
            <OmniTextField
              sx={{ width: "100%" }}
              label={"Append to the response (optional)"}
              type="textInput"
              variant="outlined"
              name={uuid()} //prevents AutoComplete Suggestions
              id={"message"}
              rowCount={4}
              multiline={true}
              value={response}
              onChange={event => setResponse(event.target.value)}
            />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Box
          sx={{
            flexGrow: 0,
            flexShrink: 1,
          }}
        >
          {cancelMessage && (
            <Button
              onClick={onCloseHandler}
              color="secondary"
              variant="contained"
              sx={{ marginRight: theme.spacing(2) }}
            >
              {cancelMessage}
            </Button>
          )}
          <Button onClick={onAcceptHandler} color="secondary" variant="contained">
            {okMessage}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default BotpressBulkFeedbackDialog;
